
import Component, {mixins} from 'vue-class-component';
import {namespace} from 'vuex-class';
import {IRouteOrder} from '@/model/Route/routeInterfaces';
import {UrlHelper} from '@/helpers/UrlHelper';
import {buildParsedRouteLegs} from '@/helpers/routeDirectionsHelper';
import {uiBus} from '@/plugins/uiBus';
import RouteExtraStopDialog from '@/components/route/RouteExtraStopDialog.vue';
import RouteStartingLocationDialog from '@/components/route/RouteStartingLocationDialog.vue';
import RoutePageHeader from '@/components/route/RoutePageHeader.vue';
import RouteAvailableOrders from '@/components/route/RouteAvailableOrders.vue';
import RouteStopsEditor from '@/components/route/RouteStopsEditor.vue';
import {RouteFormMixin} from '@/helpers/RouteFormMixin';

const routeModule = namespace('routeModule');

@Component({
  components: {RouteExtraStopDialog, RouteStartingLocationDialog, RoutePageHeader, RouteAvailableOrders, RouteStopsEditor},
})
export default class RouteCreate extends mixins(RouteFormMixin) {
  @routeModule.Action('createRoute') protected createRouteAction!: (data: any) => any;

  private loadCount: number = 0;
  private readonly LOAD_TOTAL = 2;

  protected get oldBackofficeUrl(): string {
    return UrlHelper.mayorOldRouteCreate();
  }

  created() {
    this.ons = this.$ons({
      'backend.call.OK.driversLoaded':         this.onDataLoaded,
      'backend.call.OK.ordersForRoutingLoaded': this.onDataLoaded,
      'backend.call.KO.driversLoaded':         this.onDataLoaded,
      'backend.call.KO.ordersForRoutingLoaded': this.onDataLoaded,
      'backend.call.OK.routeCreated':          this.onRouteCreated,
      'backend.call.KO.routeCreated':          this.onSaveError,
    });

    this.loadCount = 0;
    this.fetchDrivers();
    this.fetchOrdersForRouting();
    this.fetchStartingLocations();
    this.fetchChannels();
  }

  protected onDataLoaded() {
    this.loadCount++;
    if (this.loadCount >= this.LOAD_TOTAL) {
      this.loading = false;
    }
  }

  protected async onSave() {
    if (!this.canSave) { return; }
    this.saving = true;

    const timeSlotsPayload: {[key: string]: number | null} = {};
    this.selectedOrders.forEach((order) => {
      timeSlotsPayload[String(order.id)] = this.defaultTimeSlotId(order);
    });

    try {
      const orderIds: number[] = [];
      this.draggableStops.forEach(function(stop) {
        if (!stop.isExtra) {
          stop.orders.forEach(function(o: IRouteOrder) { orderIds.push(o.id); });
        }
      });
      const routeStops = this.buildRouteCalculationStops();
      const parsedLegs = await buildParsedRouteLegs(orderIds, routeStops, this.selectedDriverId as number, this.selectedStartingLocation);

      this.createRouteAction({
        driver_id:         this.selectedDriverId,
        order_ids:         orderIds,
        order_time_slots:  timeSlotsPayload,
        parsed_legs:       parsedLegs,
        extra_stops:       this.buildExtraStopsPayload(parsedLegs),
        starting_location: this.selectedStartingLocation ? {
          address: this.selectedStartingLocation.address,
          lat:     this.selectedStartingLocation.lat,
          lng:     this.selectedStartingLocation.lng,
        } : null,
      });
    } catch (e) {
      this.saving = false;
      uiBus.emit('alert', this.routeSaveErrorMessage(e));
    }
  }

  protected onRouteCreated(payload: any) {
    this.saving = false;
    const routeId = payload && payload.route_id ? payload.route_id : null;
    if (routeId) {
      this.$router.push({name: 'route', params: {routeId: String(routeId)}});
    } else {
      this.$router.push({name: 'routeList'});
    }
  }
}
